<template>
    <div>
      <el-row>
        <el-col :span="18"><div class="grid-content bg-purple" >
          <div  id="allmap" :style="{height:tableHeight+40 +'px'}"></div>
        </div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple-light rightCss">
          <div>
            <div>模块类型:</div>
            <el-radio v-model="modelType" label="Proxy" @change="modelTypeChange()">Proxy</el-radio>
            <el-radio v-model="modelType" label="Relay" @change="modelTypeChange()">Relay</el-radio>
            <el-radio v-model="modelType" label="BS" @change="modelTypeChange()">BS</el-radio>
          </div>
          <el-divider></el-divider>
          <div>
            <div>实例列表:</div>
            <div>
              <el-table
                ref="instancesData"
                :maxHeight="tableHeight - 95 + 'px'"
                :data="instancesData"
                highlight-current-row
                border
                :show-header = "false"
                @selection-change="handleInstancesChange"
                @current-change="handleInstancesSelect"
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  property="id"
                  label="名称"
                  align="center">
                </el-table-column>

              </el-table>
            </div>
          </div>
          <el-divider></el-divider>
          <div>
            <div>服务区域列表:</div>
            <div>
              <el-table
                ref="servicesScopeData"
                :maxHeight="tableHeight - 285 + 'px'"
                :data="servicesScopeData"
                highlight-current-row
                border
                :show-header = "false"
                style="width: 100%">

                <el-table-column
                  property="name"
                  label="名称"
                  align="center">
                </el-table-column>

                <el-table-column
                  fixed="right"
                  label="操作"
                  width="120">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="deleteServices(scope.$index)"
                      type="text"
                      size="small">
                      解除服务
                    </el-button>
                  </template>
                </el-table-column>

              </el-table>

            </div>
          </div>
          <div slot="footer" class="dialog-footer saveCss">

            <el-button type="primary" @click="saveServiceScope()" size="small">确 定</el-button>
          </div>
        </div></el-col>
      </el-row>
    </div>
</template>

<script>
  import { BMPGL } from "@/util/bmpgl.js"
  import avatar from '@/assets/shili.png'
  //import { BMPGLIB } from "@/util/loadLuShu.js"
  import { mapState } from 'vuex';
    export default {
        name: "bmap",
      data() {
        return {
          avatar,
          modelType:'Proxy',
          zoom: 2,
          npsAppkey:this.npsAppkey,
          test:'',
          map:null,
          imgUrl:avatar,
          instancesData:[],
          currentInstancesRow: null,
          servicesScopeData:[],
          instancesDBData:[],
          multipleInstancesSelection:[]
        }
      },
      computed: {
        ...mapState('main', ['tableHeight'])
      },
      methods: {
        initMap(){
          let _this = this;
          BMPGL(this.npsAppkey).then((BMapGL) => {
            _this.map = new BMapGL.Map("allmap");
            _this.initInstanceData();

          })
            .catch((err)=>{
              console.log(err)
            })
        },
        initMapData(){
          let _this = this;
          if(this.instancesDBData.length>0){
            //
            //https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg
            let myIcon = new BMapGL.Icon(this.avatar, new BMapGL.Size(25, 28));// 创建Marker标注，使用实例图标



            for(let i=0;i<this.instancesDBData.length;i++){
              let dbData = this.instancesDBData[i];

              if(dbData.lat && dbData.lng){
                let point = new BMapGL.Point(dbData.lat, dbData.lng);
                _this.map.centerAndZoom(point, 1);
                _this.map.enableScrollWheelZoom();


                if(dbData.instances && dbData.instances.length>0){

                  // 创建实例图标
                  let markerIcon = new BMapGL.Marker(point, {
                    icon: myIcon
                  });
                  markerIcon.disableMassClear();
                  // 将标注添加到地图

                  markerIcon.type = 2;
                  markerIcon.instances = dbData.instances;
                  _this.map.addOverlay(markerIcon);

                  let optslabel = {
                    position: new BMapGL.Point(dbData.lat, dbData.lng), // 指定文本标注所在的地理位置
                    offset: new BMapGL.Size(8, -45) // 设置文本偏移量
                  };
                  // 创建文本标注对象
                  // let label = new BMapGL.Label(dbData.instances.length, optslabel);
                  // // 自定义文本标注样式
                  // label.setStyle({
                  //   color: 'blue',
                  //   borderRadius: '5px',
                  //   borderColor: '#ccc',
                  //   padding: '1px',
                  //   fontSize: '12px',
                  //   height: '20px',
                  //   lineHeight: '20px',
                  //   fontFamily: '微软雅黑'
                  // });
                  // label.disableMassClear();
                  // _this.map.addOverlay(label);

                  // 创建信息窗口对象
                  markerIcon.addEventListener("rightclick", function(e){

                    //_this.map.openInfoWindow(infoWindow, point); //开启信息窗口
                    _this.initInstances(e.target.instances);
                  });

                }else {

                  let marker = new BMapGL.Marker(point);  // 创建标注
                  marker.type = 1;
                  marker.areaData = dbData;
                  marker.disableMassClear();
                  marker.addEventListener("rightclick", function(e){

                    //_this.map.openInfoWindow(infoWindow, point); //开启信息窗口
                    _this.addInstanceServiceScope(e.target.areaData);
                  });
                  _this.map.addOverlay(marker);              // 将标注添加到地图中
                }


              }
            }

          }




        },
        initInstances(array){
          this.instancesData = array;
        },
        addInstanceServiceScope(obj){
          let _obj = {
            id : obj.id,
            name :obj.name
          }
          this.servicesScopeData.push(_obj);
        },
        handleInstancesChange(val){
          this.multipleInstancesSelection = val;
        },
        handleInstancesSelect(val){
          this.currentInstancesRow = val;
          this.queryInstanceServicesScope(val.id);

        },
        initInstanceData(){
          this.$axios.get(this.baseUrl3 + 'area/findAllInstance/'+this.modelType)
            .then(({ data: { msg, data, code } }) => {
              if (code == 20000) {
                this.instancesDBData = data;
                this.initMapData();
              } else {
                this.$message({ showClose: true, message: msg, type: 'error' })
                console.log(msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        queryInstanceServicesScope(id){
          this.servicesScopeData = [];
          let _this = this;
          this.$axios.get(this.baseUrl3 + 'instance/findById/'+id)
            .then(({ data: { msg, data, code } }) => {
              if (code == 20000) {


                _this.map.clearOverlays();
                if(data.services_scope){
                  _this.servicesScopeData = data.services_scope;
                  for(let i=0;i<this.servicesScopeData.length;i++){
                    let servicesScopeData = this.servicesScopeData[i];

                    let path = [
                      new BMapGL.Point(servicesScopeData.lat,servicesScopeData.lng),
                      new BMapGL.Point(data.lat, data.lng),
                    ];
                    let polyline = new BMapGL.Polyline(path, {
                      clip: false,
                      geodesic: true,
                      strokeWeight: 3
                    });

                    _this.map.addOverlay(polyline);
                  }
                }





              } else {
                this.$message({ showClose: true, message: msg, type: 'error' })
                console.log(msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        deleteServices(idx){
          this.servicesScopeData.splice(idx, 1);
        },
        saveServiceScope(){

          if(this.multipleInstancesSelection.length == 0){
            this.$message.warning('请先选择实例')
            return
          }
          let modelArray = [];

          let areaIds = [];
          if(this.servicesScopeData.length>0){
            for(let i=0;i<this.servicesScopeData.length;i++){
              areaIds.push(this.servicesScopeData[i].id)
            }
          }
          for(let i=0;i<this.multipleInstancesSelection.length;i++){

            let model = {
              instanceId: this.multipleInstancesSelection[i].id,
              areaIds: areaIds
            }
            modelArray.push(model);
          }

          this.$axios.post(this.baseUrl3 + 'instance/serviceScope/add', modelArray)
            .then(({ data: { msg, data, code } }) => {
              if (code == 20000) {
                this.$message.success('操作成功')
              } else {
                this.$message({ showClose: true, message: msg, type: 'error' })
                console.log(msg)
              }
            })
            .catch(err => {
              console.log(err)
            })

        },
        modelTypeChange(){
            this.instancesDBData = [];
          let allOverlay = this.map.getOverlays();
          for (var i = 0; i < allOverlay.length; i++) {
            allOverlay[i].enableMassClear();
          }
          this.map.clearOverlays();

          this.initInstanceData();
        }
      },
      created(){

      },
      mounted() {
        this.initMap();

      },
    }
</script>

<style scoped>
  #allmap {width: 100%;overflow: hidden;margin:0;font-family:"微软雅黑";}
  .rightCss{
    margin-left: 8px;
  }
.saveCss{
  text-align: right;
  margin-top: 10px;
}
</style>
